import { render } from "./GeoAccess.vue?vue&type=template&id=7c2c859a&scoped=true"
import script from "./GeoAccess.vue?vue&type=script&lang=js"
export * from "./GeoAccess.vue?vue&type=script&lang=js"

import "./GeoAccess.vue?vue&type=style&index=0&id=7c2c859a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2c859a"]])

export default __exports__